
import Icon from "@mui/material/Icon";
import ContactIcon from "@mui/icons-material/ContactPage";
import AboutUsIcon from "@mui/icons-material/Build";
import AboutUs from "layouts/pages/landing-pages/about-us";
import ProductDesign from "layouts/pages/landing-pages/product-design";
import WebDesign from "layouts/pages/landing-pages/web-development-maintenance";
import RemoteSupport from "layouts/pages/landing-pages/remote-desktop-support";
import CyberSecurity from "layouts/pages/landing-pages/cyber-security";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import MobileAppDevelopemt from "layouts/pages/landing-pages/mobile-app-developemt-mantainance";
import ML from "layouts/pages/landing-pages/machine-learning";
import AI from "layouts/pages/landing-pages/artificial-intelligence";
import GENAI from "layouts/pages/landing-pages/generative-ai";
import DiGMar from "layouts/pages/landing-pages/digital-marketing";
import PPs from "layouts/pages/landing-pages/privacy-policy";
import TTs from "layouts/pages/landing-pages/terms-conditions";
import Refund from "layouts/pages/landing-pages/refund-policy";
import { Money, PrivacyTip, TerminalSharp } from "@mui/icons-material";

const routes = [
  {
    name: "Services",
    icon: <Icon>dashboard</Icon>,
    collapse: [
      {
        name: "Product Design",
        route: "/pages/landing-pages/product-design",
        component: <ProductDesign />,
      },
      {
        name: "Web Development & Maintenance",
        route: "/pages/landing-pages/web-development-maintenance",
        component: <WebDesign />,
      },
      {
        name: "Mobile App Developemt",
        route: "/pages/landing-pages/mobile-app-developemt-mantainance",
        component: <MobileAppDevelopemt />,
      },
      {
        name: "Remote Desktop Support",
        route: "/pages/landing-pages/remote-desktop-support",
        component: <RemoteSupport />,
      },
      {
        name: "Cyber Security",
        route: "/pages/landing-pages/cyber-security",
        component: <CyberSecurity />,
      },
      {
        name: "Digital Marketing",
        route: "/pages/landing-pages/digital-marketing",
        component: <DiGMar />,
      },
      {
        name: "Machine Learning (ML)",
        route: "/pages/landing-pages/machine-learning",
        component: <ML />,
      },
      {
        name: "Artificial Intelligence (AI)",
        route: "/pages/landing-pages/artificial-intelligence",
        component: <AI />,
      },
      {
        name: "Generative AI (GenAI)",
        route: "/pages/landing-pages/generative-ai",
        component: <GENAI />,
      },
    ],
  },
  
  {
            icon: <AboutUsIcon />,
            name: "about us",
            route: "/pages/landing-pages/about-us",
            component: <AboutUs />,
  },
  {
            icon: <PrivacyTip />,
            name: "Terms & conditions",
            route: "/pages/landing-pages/terms-conditions",
            component: <TTs />,
  },
  {
            icon: <TerminalSharp />,
            name: "Privacy Policy",
            route: "/pages/landing-pages/privacy-policy",
            component: <PPs/>,
  },
  {
            icon: <Money />,
            name: "Refund Policy",
            route: "/pages/landing-pages/refund-policy",
            component: <Refund/>,
},
  {
            icon: <ContactIcon />,
            name: "Contact Us",
            route: "/pages/landing-pages/contact-us",
            component: <ContactUs />,
  },
];

export default routes;
